<template>
  <tr>
    <td class="row-label-wrapper" v-if="checklistItem.required == true"><span style="color:red;">* </span>{{checklistItem.label}}</td>
    <td class="row-label-wrapper" v-else>{{checklistItem.label}}</td>
    <div v-if="!this.$vuetify.breakpoint.lg && !this.$vuetify.breakpoint.xl">
    <td class="checkbox-row">
        <div class="checkbox-wrapper">
        <v-checkbox :disabled="isDisabled" success id="yesValue" v-model="checklistItem.yesChecked" label="Complete"></v-checkbox>
        </div>
        <div class="checkbox-wrapper">
          <v-checkbox :disabled="isDisabled" error id="noValue" v-model="checklistItem.noChecked" label="Required"></v-checkbox>
        </div>
        <div class="checkbox-wrapper">
          <v-checkbox :disabled="isDisabled" info :class="disabledStyle" id="progressValue" v-model="checklistItem.progressChecked" label="In Progress"></v-checkbox>
        </div>
        <div class="checkbox-wrapper">
          <v-checkbox :disabled="isDisabled" id="naValue" v-model="checklistItem.naChecked" label="N/A"></v-checkbox>
        </div>
    </td>
    </div>
    <div style="margin-top:25px!important"  v-else>
      <td><v-checkbox :disabled="isDisabled" success id="yesValue" v-model="checklistItem.yesChecked" label="Complete"></v-checkbox></td>
      <td><v-checkbox :disabled="isDisabled" error id="noValue" v-model="checklistItem.noChecked" label="Required"></v-checkbox></td>
      <td><v-checkbox :disabled="isDisabled" :class="disabledStyle" color="primary" id="progressValue" v-model="checklistItem.progressChecked" label="In Progress"></v-checkbox></td>
      <td><v-checkbox :disabled="isDisabled" id="naValue" v-model="checklistItem.naChecked" label="N/A"></v-checkbox></td>
    </div>
    <td class="type-input-wrapper"  :disabled="isDisabled" style="width:90px;" v-if="checklistItem.type.toLowerCase() === 'bool'"></td>
    <td class="type-input-wrapper" :disabled="isDisabled" style="width:125px; padding-right: 0;" v-else-if="checklistItem.type.toLowerCase() === 'date'">
      <v-menu
        v-model="showDateDialog"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
        :disabled="isDisabled"
      >
        <v-date-picker v-model="checklistItem.info" @input="showDateDialog = false"></v-date-picker>
        <template v-slot:activator="{ on }">
          <v-text-field :disabled="isDisabled"  class="text-xs-center" style="font-size:14px!important; margin-top:25px!important;" v-model="checklistItem.info" label="Date" :clearable="true" readonly v-on="on"></v-text-field>
        </template>
      </v-menu>
    </td>
    <td class="type-input-wrapper" style="width:90px;" v-else-if="checklistItem.type.toLowerCase() === 'number'"><v-text-field :disabled="isDisabled" style="font-size:14px !important" label="Total" v-model="checklistItem.info"  type="number"></v-text-field></td>
    <td class="type-input-wrapper" :disabled="isDisabled" style="width:90px;" v-else></td>
    <td class="initials-wrapper" style="padding-right: 0; padding-left: 0; "><v-text-field  :disabled="isDisabled" readonly style="font-size:14px;" v-model="checklistItem.checkedBy" auto-grow rounded>  </v-text-field></td>
    <td><v-text-field :disabled="isDisabled" :id="checklistItem.id" style="font-size:14px" label="Notes" v-model="checklistItem.notes" auto-grow rounded>  </v-text-field></td>
    <td class="actions-wrapper">
      <v-flex class="actions-row">
        <v-icon
          color="accent"
          class="checklist-action-icon mr-2"
          @click="showDetails(checklistItem)"
        >
          mdi-square-edit-outline
        </v-icon>
        <v-icon
          color="accent"
          class="checklist-action-icon mr-2"
          @click="selectFile"
          v-if="!isDisabled"
        >
        mdi-upload
        </v-icon>
        <input type="file" ref="fileInput" multiple @change="onFileChange" style="display: none;" />
        <v-icon
          color="error"
          class="mr-2"
          @click="toggleDelete"
          v-if="!isDisabled"
        >
          mdi-trash-can-outline
        </v-icon>
      </v-flex>
      <checklist-details
        :saveUpdatedChecklist="saveChecklist"
        :showDialog="showDetailsDialog"
        :checklistItem="checklistItem"
        :toggle="toggleDetails"
        :currentUser="this.currentUser">
      </checklist-details>
    </td>
    <template>
      <v-row justify="center">
        <v-dialog v-model="showDeleteDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline" v-bind:style="{ backgroundColor: '#1e345d', color: 'white'}">
              Confirm Delete
              <v-spacer></v-spacer>
              <v-btn icon @click="toggleDelete"><v-icon>close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pb-1"> Are you sure you want delete this item?</v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn outlined color="error" @click="deleteItem">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </tr>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ChecklistDetails from '@/components/checklists/PlanningChecklistDetails'
export default {
  name: 'planning-checklist',
  components: {
    ChecklistDetails
  },
    created: () => { },

    data: () => ({
    checklistToRemove: null,
    imageType: '',
    showDateDialog: false,
    showDeleteDialog: false,
    showDetailsDialog: false,
    displayDoc: false,
    displayImage: false,
    displayChange: false,
    submitted: false,
    files: [],
    imagesToUpload: [],
    documentsToUpload: [],
    createUploadSingle: {
      workOrderTaskId: null,
      userId: null,
      file: null,
      documentTypeId: null
    },
    fileName: '',
  }),
  props: {
    checklistItem: {
      type: Object,
      required: true
    },
    updateSaved: {
      type: Function,
      required: true
    },
    checklistId: {
      type: Number,
      required: true
    }
  },
  methods: {
    ...mapActions({
      updateChecklist: 'checklist/updateChecklist',
      uploadCreateDoc: 'document/uploadCreateDocument',
      uploadCreateImg: 'image/uploadCreateImage',
      uploadCreateChangeDoc: 'changeOrderDocument/uploadCreate',
      loadAllDocumentTypes: 'documentType/loadAllDocumentTypes',
      loadDocs: 'document/loadDocsByTask',
      loadImages: 'image/loadImagesByTask',
      loadChangeOrders: 'changeOrder/loadByTask',
      updateDoc: 'document/updateDocument',
      updateImage: 'image/updateImage'
    }),
    saveChecklist() {
      this.updateChecklist(this.currentChecklist)
      this.updateSaved(true)
    },
    showDetails (checklistItem) {
      this.toggleDetails()
    },
    toggleDetails () {
      this.showDetailsDialog = !(this.showDetailsDialog)
    },
    toggleDelete () {
      this.showDeleteDialog = !(this.showDeleteDialog)
    },
    deleteItem () {
      let index = this.currentChecklist.checklistObject.findIndex(cl => cl.label === this.checklistItem.label)
      this.currentChecklist.checklistObject.splice(index, 1)
      this.saveChecklist()
    },
    onFileChange (e) {
      this.files = e.target.files || e.dataTransfer.files
      for (let file of this.files) {
        if (file.type.includes('image/')) {
          this.imagesToUpload.push(file)
        } else {
          this.documentsToUpload.push(file)
        }
      }

      this.uploadCreateMethod()
    },
    selectFile () {
      this.$refs.fileInput.click()
    },
    async uploadCreateMethod () { // TODO: Seperate this method, so in smaller chunks
      this.submitted = true
      // Set User & Task Id
      this.createUploadSingle.userId = this.currentUser.id
      this.createUploadSingle.workOrderTaskId = this.selectedTask.id

      await this.uploadImages()
      await this.uploadDocuments()

      this.submitted = false
      this.files = []
      this.imagesToUpload = []
      this.documentsToUpload = []
      this.fileName = ''
    },
    async uploadDocuments () {
      this.submitted = true
      for (let file of this.documentsToUpload) {
        this.fileName = file.name
        this.createUploadSingle.file = file
        this.createUploadSingle.stageCreatedAt = 'Planning'
        let documents = await this.uploadCreateDoc(this.createUploadSingle)
        let index = this.currentChecklist.checklistObject.findIndex(cl => cl.label === this.checklistItem.label)
        for (var i = 0; i < documents.length; i++) {
          this.currentChecklist.checklistObject[index].documents.push({ id: documents[i].id, fileName: documents[i].fileName })
        }
      }
      this.loadDocs(this.selectedTask.id)
      this.saveChecklist()
    },
    async uploadImages () {
      this.imageType = 'Pre Job Image'
      // Auto populating the image type for each stage
      if (this.imageType != null) {
        this.types.forEach(x => {
          if (this.imageType === x.text) {
            this.createUploadSingle.documentTypeId = x.value
          }
        })
      }

      for (let file of this.imagesToUpload) {
        this.fileName = file.name
        this.createUploadSingle.file = file
        let documents = await this.uploadCreateImg(this.createUploadSingle)
        let index = this.currentChecklist.checklistObject.findIndex(cl => cl.label === this.checklistItem.label)
        if (documents.length < 1) {
          for (var i = 0; i < documents.length; i++) {
            this.currentChecklist.checklistObject[index].images.push({ id: documents[i].id, fileName: documents[i].fileName })
          }
        } else {
          this.currentChecklist.checklistObject[index].images.push({ id: documents.id, fileName: documents.fileName })
        }
      }
      this.loadImages({ taskId: this.selectedTask.id, size: 'small' })
      this.saveChecklist()
    }
  },
  watch: {
    'checklistItem.yesChecked'(newValue) {
       this.updateSaved(false)
      if (newValue === true) {
        this.checklistItem.yesChecked = true
        this.checklistItem.noChecked = false
        this.checklistItem.naChecked = false
        this.checklistItem.progressChecked = false
      }
      this.checklistItem.checkedBy = `${this.currentUser.firstName.charAt(0)}${this.currentUser.lastName.charAt(0)}`
    },
    'checklistItem.noChecked'(newValue) {
      this.updateSaved(false)
      if (newValue === true) {
        this.checklistItem.yesChecked = false
        this.checklistItem.noChecked = true
        this.checklistItem.naChecked = false
        this.checklistItem.progressChecked = false
      }
      this.checklistItem.checkedBy = `${this.currentUser.firstName.charAt(0)}${this.currentUser.lastName.charAt(0)}`
    },
    'checklistItem.naChecked'(newValue) {
      this.updateSaved(false)
      if (newValue === true) {
        this.checklistItem.yesChecked = false
        this.checklistItem.noChecked = false
        this.checklistItem.naChecked = true
        this.checklistItem.progressChecked = false
      }
      this.checklistItem.checkedBy = `${this.currentUser.firstName.charAt(0)}${this.currentUser.lastName.charAt(0)}`
    },
    'checklistItem.progressChecked'(newValue) {
       this.updateSaved(false)
      if (newValue === true) {
        this.checklistItem.yesChecked = false
        this.checklistItem.noChecked = false
        this.checklistItem.naChecked = false
        this.checklistItem.progressChecked = true
      }
      this.checklistItem.checkedBy = `${this.currentUser.firstName.charAt(0)}${this.currentUser.lastName.charAt(0)}`
    },
    'checklistItem.info'(newValue) {
      this.updateSaved(false)
    },
    'checklistItem.notes'(newValue) {
       this.updateSaved(false)
    },
    'checklistId'(oldValue, newValue) {
      if (oldValue !== newValue) {  this.updateSaved(true)}
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentChecklist: 'checklist/selectedChecklist',
      errorDocument: 'document/errorDocument',
      errorImage: 'image/error',
      types: 'documentType/selectList',
      images: 'image/imagesByTask',
      documents: 'document/documentsByTask',
      docStatus: 'document/status',
      imageStatus: 'image/status',
      selectedTask: 'workOrderTask/selectedTask',
      userRole: 'user/role'
    }),
    documentLength: {
      get () {
        if (this.checklistItem.documents || this.checklistItem.images) {
          return this.checklistItem.documents.length + this.checklistItem.images.length
        } else {
          return '0'
        }
      }
    },
    isDisabled () {
      if (this.userRole === 'Sub Foreman') {
        return true
      } else {
        return false
      }
    },
    disabledStyle () {
      if (this.userRole === 'Sub Foreman') {
        return ''
      } else {
        return 'blue-text'
      }
    }
  }
}
</script>
<style>
  .row-label-wrapper {
    font-size: 14px;
    font-weight: 500;
    padding-right: 10px !important;
    max-width: 240px !important;
  }
  .blue-text .v-label {
    color:#1e345d!important;
    width:85px!important;
  }
  .blue-text .v-icon {
    color:#1e345d!important;
  }
  .checkbox-wrapper .v-label {
    width: 100%;
    font-size: 14px !important;
  }
  .checkbox-row {
    padding: 20px 0 !important;
  }
  .checkbox-wrapper .v-input--selection-controls {
    margin-top: 0 !important;
    height: 30px;
  }
  .documents-wrapper .v-input input,
  .initials-wrapper .v-input input {
    text-align: center;
  }
  .actions-wrapper {
    padding: 0 !important;
  }
  .actions-row {
    display: inline-flex;
  }
  @media only screen and (max-width: 710px) {
  .initials-wrapper {
    display: none;
  }
  #notesCol {
    display: none;
  }
  }
  @media only screen and (max-width: 630px) {
    .documents-wrapper {
      display: none;
    }
    .actions-wrapper {
      padding-left: 16px !important;
    }
  }
  @media only screen and (max-width: 534px) {
    .type-input-wrapper {
      display: none;
    }
  }
  @media only screen and (max-width: 460px) {
    .actions-row {
      display: block;
      float: right;
    }
    .checklist-action-icon {
      margin-bottom: 5px !important;
    }
    .checkbox-row {
      padding: 20px 0 !important;
    }
  }
 .v-input__slot{
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
</style>
